import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const HomeIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  isActive = false,
  ...props
}) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8925 0.869184C8.19761 0.597872 8.5917 0.447998 9 0.447998C9.40829 0.447998 9.80238 0.597872 10.1075 0.869184L13.3858 3.78335L13.5942 2.53002C13.6121 2.42206 13.6511 2.31869 13.709 2.22582C13.7669 2.13295 13.8426 2.05239 13.9316 1.98875C14.0206 1.9251 14.1213 1.87961 14.2279 1.85488C14.3345 1.83015 14.445 1.82665 14.5529 1.8446C14.6609 1.86255 14.7642 1.90158 14.8571 1.95948C14.95 2.01737 15.0305 2.09299 15.0942 2.18202C15.1578 2.27105 15.2033 2.37174 15.2281 2.47835C15.2528 2.58496 15.2563 2.69539 15.2383 2.80335L14.8583 5.09168L17.0542 7.04418C17.2109 7.19311 17.3037 7.39715 17.3128 7.6132C17.3219 7.82925 17.2467 8.04038 17.1031 8.202C16.9594 8.36362 16.7585 8.46307 16.5429 8.47933C16.3273 8.4956 16.1138 8.42742 15.9475 8.28918L15.5608 7.94585L14.905 14.4992C14.8639 14.9106 14.6713 15.292 14.3647 15.5694C14.058 15.8467 13.6593 16.0002 13.2458 16H4.75417C4.34086 16 3.9423 15.8464 3.63586 15.5691C3.32942 15.2917 3.13696 14.9104 3.09583 14.4992L2.44083 7.94585L2.05333 8.28918C1.88705 8.42742 1.67354 8.4956 1.45791 8.47933C1.24229 8.46307 1.04143 8.36362 0.897768 8.202C0.754107 8.04038 0.678894 7.82925 0.688018 7.6132C0.697142 7.39715 0.789889 7.19311 0.946665 7.04418L7.8925 0.869184ZM3.96417 6.59168C3.97972 6.64279 3.99028 6.69585 3.99583 6.75085L4.75417 14.3342H13.2458L14.0042 6.75085C14.0097 6.69529 14.0203 6.64252 14.0358 6.59252L9 2.11418L3.96417 6.59168Z"
      fill={isActive ? 'url(#gradient)' : '#333333'}
    />
    {isActive && (
      <defs>
        <linearGradient
          id="gradient"
          x1="0.351013"
          y1="5.78012"
          x2="15.6358"
          y2="5.02624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD84BE" />
          <stop offset="0.494253" stopColor="#FB7BDB" />
          <stop offset="1" stopColor="#BF78F2" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export default HomeIcon;
